<section class="guests">

  <!-- Summary tiles — filled by GuestAccount once the list is loaded. -->
  <div class="guests__stats" data-id="guests-summary" hidden></div>

  <!-- Grid (or loading / error message), rendered by GuestAccount.js. A click
       on a row opens the account. -->
  <div class="admin-users__state" data-id="guests-state"></div>

</section>
